import { useContext } from 'react';
import useSelectedFilterSet from '../../../../../hooks/useSelectedFilterSet';
import FilterSetForm from '../../../FilterSet/FilterSetForm';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const EditFilterSetButton = ({ Context }) => {
  const { modalHandler } = useContext(Context);
  const selectedFilterSet = useSelectedFilterSet(Context);

  const onClick = () => {
    modalHandler.openModal({
      content: () => (
        <FilterSetForm
          Context={Context}
          filterSet={selectedFilterSet}
          onSubmit={modalHandler.closeModal}
        />
      ),
      stickToTop: true
    });
  };

  if (!selectedFilterSet) return null;

  return (
    <LBButton
      variant='ghost'
      size='icon'
      onClick={onClick}
      data-cy='edit-filter-pencil-btn'
    >
      <Icon name='Pencil' color='chambray' />
    </LBButton>
  );
};

export default EditFilterSetButton;
